import { ContainerModule, interfaces } from 'inversify';
import { CheckMarkingToolNameUniquenessServiceImpl, ICheckMarkingToolNameUniquenessService } from './services/CheckMarkingToolNameUniqueness.service';

export const markingToolsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(ICheckMarkingToolNameUniquenessService.$).to(CheckMarkingToolNameUniquenessServiceImpl).inSingletonScope();
});
